module.exports = __webpack_public_path__ + "assets/img/stihl_allinclusive_sticker_fi.393034d4.png";